export default "__VITE_ASSET__DhV4qokq__"